import { AdSlot } from './ad-slot';
import { AdSlotFormatEnum, AdSlotSettingLinkPropertiesDto, AdSlotSettingStyleDto } from '../dto/recs.dto';

export class AdSlotSettings {
  private adSlot?: AdSlot;

  private readonly positionSelector?: string | null;

  private readonly maxNumberOfColumns?: number | null;

  private readonly format?: AdSlotFormatEnum | null;

  private readonly datasetId?: string | null;

  private readonly impressionTrackTimeout?: number | null;

  private readonly itemImpressionTrackTimeout?: number | null;

  private readonly impressionMinimumVisibleThreshold?: number | null;

  private readonly itemImpressionMinimumVisibleThreshold?: number | null;

  private readonly headingText?: string | null;

  private readonly style?: AdSlotSettingStyleDto;

  private readonly privacyPolicyUrl?: string | null;

  private readonly linkProperties?: AdSlotSettingLinkPropertiesDto;

  public getAdSlot (): AdSlot | null {
    return this.adSlot ?? null;
  }

  public setAdSlot (adSlot?: AdSlot): this {
    this.adSlot = adSlot;
    return this;
  }

  public getPositionSelector (): string | null {
    return this.positionSelector ?? null;
  }

  public getMaxNumberOfColumns (): number | null {
    return this.maxNumberOfColumns ?? null;
  }

  public getFormat (): AdSlotFormatEnum {
    return this.format ?? AdSlotFormatEnum.AUTO;
  }

  public getDatasetId (): string | null {
    return this.datasetId ?? null;
  }

  public getImpressionTrackTimeout (): number | null {
    return this.impressionTrackTimeout ?? null;
  }

  public getItemImpressionTrackTimeout (): number | null {
    return this.itemImpressionTrackTimeout ?? null;
  }

  public getImpressionMinimumVisibleThreshold (): number | null {
    return this.impressionMinimumVisibleThreshold ?? null;
  }

  public getItemImpressionMinimumVisibleThreshold (): number | null {
    return this.itemImpressionMinimumVisibleThreshold ?? null;
  }

  public getHeadingText (): string | null {
    return this.headingText ?? null;
  }

  public getStyle (): AdSlotSettingStyleDto {
    return this.style ?? {};
  }

  public getPrivacyPolicyUrl (): string | null {
    return this.privacyPolicyUrl ?? null;
  }

  public getLinkProperties (): AdSlotSettingLinkPropertiesDto {
    return this.linkProperties ?? {};
  }
}
